import { render, staticRenderFns } from "./ParcelsReceiveProcess.vue?vue&type=template&id=0f482832"
import script from "./ParcelsReceiveProcess.vue?vue&type=script&lang=js"
export * from "./ParcelsReceiveProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports